import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createPersonBirthday,
  updatePersonBirthday,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const usePersonDateOfBirthDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const personDateOfBirthDispatch = ({
    personUid,
    data,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const { Year, Month, Day } = data;

    if (!Month || !Year || !Day) {
      const DateOfBirth = null;
      const requestData = {
        ApplicationUid,
        PersonUid: personUid,
        data: {
          DateOfBirth,
        },
        onSuccess,
        onError,
      };
      if (defaultValues.Month) {
        dispatch(
          updatePersonBirthday({
            ...requestData,
          }),
        );
        return;
      }

      dispatch(
        createPersonBirthday({
          ...requestData,
        }),
      );
      return;
    }

    const DateOfBirth = new Date(
      Date.UTC(Number(Year), Number(Month - 1), Number(Day)),
    );

    const requestData = {
      ApplicationUid,
      PersonUid: personUid,
      data: {
        DateOfBirth,
      },
      onSuccess,
      onError,
    };

    if (defaultValues.Month) {
      dispatch(
        updatePersonBirthday({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createPersonBirthday({
        ...requestData,
      }),
    );
  };

  return { personDateOfBirthDispatch };
};

export default usePersonDateOfBirthDispatch;
